// src/geom/PolygonWrapper.js
import PolygonDefault, * as PolygonNS from './../../node_modules/ol/geom/Polygon.js'; // OL original module

// Combine default class + static methods
const Polygon = PolygonDefault;

// Copy all static members from OL module to Polygon class
Object.keys(PolygonNS).forEach(key => {
    if (key !== 'default') {
        Polygon[key] = PolygonNS[key];
    }
});

export default Polygon;
